<template>
  <div>
    <div class="d-flex align-center mb-6 h-35px px-1">
      <!--      <div class="mr-1 btn-group">-->
      <!--        <span class="mr-auto my-0 h5 font-weight-regular"> Add gift</span>-->
      <!--      </div>-->
      <b-button-group class="ml-auto" size="">
        <button @click="addRule" class="btn btn-outline-info">
          <b-icon-diamond /> Add gift
        </button>
      </b-button-group>
    </div>
    <template v-for="(item, index) in currentQuery">
      <Action
        :rule="item"
        :options="options"
        :userId="userId"
        :selectedStatusId="selectedStatusId"
        :key="index"
        class="mt-2 px-1"
        ref="action"
      />
    </template>
  </div>
</template>

<script>
import Action from "@/own/components/orderManagement/promotions/SKUQuantityBuilder/Action.vue";
export default {
  name: "ActionGroup",
  components: { Action },
  props: {
    currentQuery: {
      type: Array,
      required: true,
    },
    options: {
      type: Array,
    },

    userId: {
      required: false,
    },
  },
  data: function () {
    return { selectedStatusId: null };
  },
  mounted: function () {
    this.currentQuery.forEach((rule) => {
      if (rule?.systemCode) {
        rule.value = Number(rule.value);
      }
    });

    this.$nextTick(() => {
      if (this.currentQuery.length === 0) {
        this.addRule();
      }
    });
  },
  // computed: {
  //   selectedStatusId: function () {
  //     // Status ID is 6
  //     return this.currentQuery.find((option) => option.id === 6)?.value;
  //   },
  // },
  methods: {
    addRule() {
      const newGroup = {
        id: this.options[0].index,
        value: null,
        quantity: null,
      };
      this.currentQuery.push(newGroup);
      this.$nextTick(() => {
        this.$refs.action.forEach((comp) => {
          comp.$v.$touch();
        });
      });
    },
  },
  // watch: {
  //   currentQuery: {
  //     handler() {
  //       // Status ID is 6 return_status
  //       this.selectedStatusId = this.currentQuery.find(
  //         (option) => option.id === 6 || option.id === 13
  //       )?.value;
  //     },
  //     deep: true,
  //   },
  // },
};
</script>
